
import isNaN from "lodash/isNaN";
import isUndefined from "lodash/isUndefined";

import settings from "../settings";

export let DEFAULT_ERROR = '—';
export let ROMANS = ['N', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];

const wgsdkThousands = (number: number, reduce: boolean = false, startFrom?: number) => {

  var result,
    i = 0;

  if (reduce && startFrom <= number) {
    var suffix = '';

    if (number >= 1000000) {
      number /= 1000000;
      suffix = ' M';
    } else if (number >= 100000) {
      number /= 1000;
      suffix = ' K';
    }
    result = number;
    if (suffix) {
      result = number.toFixed(2) + suffix;
    }
    return result;
  }

  var dotted = '';
  // @ts-ignore
  number = number.toString();
  var dotPosition = `${number}`.search(/\./);
  if (dotPosition > -1) {
    dotted = settings.formats ? settings.formats.decimal || '.' : ',';
    dotted += `${number}`.substr(dotPosition + 1);
    // @ts-ignore
    number = number.substr(0, dotPosition);
  }

  result = '';

  var sign = '';
  if (`${number}`.substr(0, 1) === '-') {
    // @ts-ignore
    number = `${number}`.substr(1);
    sign = '-';
  }

  var len = `${number}`.length,
    separator = settings.formats ? settings.formats.thousand || ' ' : ' ';
  for (i = 0; i < len; ++i) {

    if (i !== 0 && len - i !== 0 && (len - i) % 3 === 0) {
      result += separator;
    }
    result += `${number}`.charAt(i);
  }
  return sign + result + dotted;
};

export const thousands = (value: any, reduceStartFrom: number) => {
  value = Math.round(parseFloat(value));
  if (isNaN(value)) {
    return DEFAULT_ERROR;
  }
  return wgsdkThousands(value, !!reduceStartFrom, reduceStartFrom);
};

export const floats = function (value, digits) {
  value = parseFloat(value);
  if (isNaN(value)) {
    return DEFAULT_ERROR;
  }

  if (isUndefined(digits)) {
    digits = 1;
  }

  return wgsdkThousands(round(value, digits));
};

export const percent = function (value, fixed) {
  value = parseFloat(value);
  if (isNaN(value)) {
    return DEFAULT_ERROR;
  }

  if (isUndefined(fixed)) {
    fixed = 2;
  }

  var text = '0%';
  if (value >= 100) {
    text = '100%';
  } else if (value > 0) {
    text = wgsdkThousands(value.toFixed(fixed)) + '%';
  }
  return text;
};

export const toRoman = function (value) {
  return ROMANS[value];
};

export const toArabic = function (value) {
  return ROMANS.indexOf(value);
};

export const round = (value, ndigits) => {
  const shift = Math.pow(10, ndigits);
  return Math.round(value * shift) / shift;
};